import { SearchFilters } from '@cinch-nx/data-search'
import { useSearchFiltersFormatting } from '../use-search-filters-formatting'
import { useUsedCarsData } from '../use-used-cars-data/use-used-cars-data'

export interface FilterItem {
  key: string
  value: string
  display: string
}

export const MAX_FILTER_INDEX_TO_SHOW = 4

export const useSearchAlertFiltersFormatting = () => {
  const { formatFilterPill } = useSearchFiltersFormatting()
  const { searchParams } = useUsedCarsData()

  const getFlattenedFilters = (): Array<{
    key: string
    value: string
    display: string
  }> =>
    Object.entries(searchParams).flatMap(([key, values]) => {
      if (!Array.isArray(values)) {
        // if the value isn't an array, it's a non-filter param, and can be discarded
        return []
      }
      const filterKey = key as keyof SearchFilters
      const filterValues =
        filterKey === 'financeType'
          ? values.filter((value) => value !== 'any')
          : values

      return filterValues.map((value, index) => ({
        key: `${key}-${index}`,
        value,
        display: formatFilterPill(filterKey, value, searchParams.financeType),
      }))
    })

  const transformExtraFilter = (
    filterItem: FilterItem,
    index: number,
    filters: FilterItem[],
  ) => {
    if (
      index === MAX_FILTER_INDEX_TO_SHOW &&
      filters.length > MAX_FILTER_INDEX_TO_SHOW + 1
    ) {
      return {
        key: 'extras',
        value: 'extras',
        display: `+ ${filters.length - MAX_FILTER_INDEX_TO_SHOW} more filters`,
      }
    }

    return filterItem
  }

  return getFlattenedFilters()
    .map((element, index, array) => transformExtraFilter(element, index, array))
    .slice(0, MAX_FILTER_INDEX_TO_SHOW + 1)
}
